import { render } from "./LearningExam.vue?vue&type=template&id=61e1857a"
import script from "./LearningExam.vue?vue&type=script&lang=js"
export * from "./LearningExam.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__